import React from 'react';
import PropTypes from 'prop-types';
import Button from '../General/Button';
import Loading from '../General/Loading';
import {
  ContainerStyled as Container,
  RetrySvgStyled as RetrySvg,
  TitleStyled as Title,
  MessageStyled as Message,
  UnderlineButtonStyled as UnderlineButton,
} from './styles/LogoutStyled';

const LogoutRetry = ({ retry, close, loading }) => {
  if (loading)
    return (
      <Container>
        <Loading />
      </Container>
    );

  return (
    <Container>
      <RetrySvg />
      <Title>Ha ocurrido un error</Title>
      <Message>
        No ha sido posible cerrar tu sesión, vuelve a intentarlo
      </Message>
      <Button color="bubbleGum" maxWidth="100%" margin="0 auto" click={retry}>
        Reintentar
      </Button>
      <UnderlineButton onClick={close}>Cancelar</UnderlineButton>
    </Container>
  );
};

LogoutRetry.propTypes = {
  retry: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default LogoutRetry;
